import React from 'react';
import { Search, Shield, TrendingUp } from 'lucide-react';

const FeatureSection = () => {
  const features = [
    {
      id: 1,
      icon: Search,
      title: 'Detailed Trademark Search Service',
      description: 'Our AI-powered search platform analyzes millions of existing trademarks to spot any potential conflicts before you file your application. We carry out thorough federal, state, and common law searches to ensure your brand name, logo, or slogan is fully available for registration, helping you save time and avoid costly rejection issues.',
      image: '/assets/img/h1.jpg',
      reverse: false
    },
    {
      id: 2,
      icon: Shield,
      title: 'Full Registration & Filing Support',
      description: 'We handle the entire trademark filing process from beginning to end, including preparing applications and submitting them to the USPTO. Our experienced trademark attorneys review every detail, select the correct classification categories, write accurate descriptions, and manage office action responses to increase your chances of approval.',
      image: '/assets/img/h2.jpg',
      reverse: true
    },
    {
      id: 3,
      icon: TrendingUp,
      title: 'Continuous Brand Protection Service',
      description: 'Protect your trademark with ongoing monitoring services that alert you to possible infringement threats. We constantly track new trademark filings, domain registrations, and online platforms to detect unauthorized use of your brand, while also providing enforcement support to defend your intellectual property rights.',
      image: '/assets/img/h3.jpg',
      reverse: false
    }
  ];

  return (
    <div className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {features.map((feature, index) => (
          <div
            key={feature.id}
            className={`flex flex-col ${feature.reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-12 mb-32 last:mb-0`}
          >
            {/* Image Side */}
            <div className="w-full md:w-1/2">
              <div className="relative">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="rounded-2xl shadow-2xl w-full h-auto"
                />
                {/* Decorative mockup overlays */}
                <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-white rounded-xl shadow-xl p-4 hidden lg:block">
                  <div className="w-full h-full bg-gradient-to-br from-gray-100 to-gray-200 rounded-lg flex items-center justify-center">
                    <feature.icon className="w-12 h-12 text-[#168356]" />
                  </div>
                </div>
              </div>
            </div>

            {/* Content Side */}
            <div className="w-full md:w-1/2">
              <div className="mb-6">
                <div className="w-16 h-16 bg-black rounded-2xl flex items-center justify-center mb-6 transition-transform duration-300 hover:scale-110 hover:rotate-6">
                  <feature.icon className="w-8 h-8 text-[#168356]" />
                </div>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
                {feature.title}
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureSection;